import styled from 'styled-components';

interface StyledProps {
  $bgColor?: string;
}

export const EvtNaviType2 = styled.div<StyledProps>`
  width: 100%;
  max-width: 1902px;
  margin: 0 auto;
  position: relative;

  .navi-inner {
    display: flex;
    align-items: center;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: none;
    background-color: ${({ $bgColor }) => $bgColor || '#000'};

    &::-webkit-scrollbar {
      display: none;
    }

    .draggable-scroller {
      width: 100%;
    }
  }
`;
